var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$vuetify.breakpoint.smAndDown)?_c('MobileUserProfile',{attrs:{"menuItems":_vm.menuItems}}):_c('DesktopUserProfile',{attrs:{"menuItems":_vm.menuItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }